import { GTAG, RGPD_SET_EVERYTHING } from '../actions/rgpd';

export default (
  state: RGPDState = {
    visible: true,
    options: {
      [GTAG]: false,
    },
  },
  // TODO
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: Record<string, any>
): RGPDState => (action.type === RGPD_SET_EVERYTHING ? action.payload : state);

export type RGPDState = {
  visible: boolean;
  options: Record<string, boolean>;
};
